document.addEventListener('DOMContentLoaded', function () {
  var footer = document.querySelector('.footer[data-footer-accordion]');
  if (!footer) return;

  var enableAccordion = footer.dataset.footerAccordion;
  if (enableAccordion === 'false' || enableAccordion === '0') return;

  var blocks = footer.querySelectorAll('.footer-block.footer-block--accordion');
  if (!blocks.length) return;

  var mq = window.matchMedia('(max-width: 749px)');

  function setMode() {
    blocks.forEach(function (block) {
      var content = block.querySelector('.footer-accordion__content');
      if (!content) return;

      if (mq.matches) {
        block.classList.remove('footer-block--open');
        content.style.maxHeight = '0px';
      } else {
        block.classList.add('footer-block--open');
        content.style.maxHeight = 'none';
      }
    });
  }

  function onToggleClick(evt) {
    if (!mq.matches) return;

    var toggle = evt.currentTarget;
    var block = toggle.closest('.footer-block.footer-block--accordion');
    if (!block) return;

    var content = block.querySelector('.footer-accordion__content');
    if (!content) return;

    var isOpen = block.classList.contains('footer-block--open');

    // close all
    blocks.forEach(function (other) {
      var otherContent = other.querySelector('.footer-accordion__content');
      if (!otherContent) return;
      other.classList.remove('footer-block--open');
      otherContent.style.maxHeight = '0px';
      var otherToggle = other.querySelector('.footer-accordion__toggle');
      if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      block.classList.add('footer-block--open');
      content.style.maxHeight = content.scrollHeight + 'px';
      toggle.setAttribute('aria-expanded', 'true');
    } else {
      block.classList.remove('footer-block--open');
      content.style.maxHeight = '0px';
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  blocks.forEach(function (block) {
    var toggle = block.querySelector('.footer-accordion__toggle');
    if (!toggle) return;
    toggle.addEventListener('click', onToggleClick);
  });

  setMode();
  if (mq.addEventListener) {
    mq.addEventListener('change', setMode);
  } else if (mq.addListener) {
    mq.addListener(setMode);
  }
});